import React, { Component } from "react";
import { connect } from "react-redux";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Button from "react-validation/build/button";
import Select from "react-validation/build/select";
import moment from "moment";
import DatePicker from "react-datepicker";
//import clearForm from "../utils/clearForm";
import * as validations from "./lib/validations";
import {
  registrationInquiryInsertUpdate,
  clearUpdate,
  checkUserVerifyOtpDetails,
  ResendOtpDetails,
  getAllAdvertisement
} from "../actions";
import updateGrid from "../utils/updateGrid";
import { Redirect } from "react-router-dom";
import Modal from "react-responsive-modal";
import _ from "lodash";
import textToCapitalize from "../utils/textToCapitalize";
const keys = require("../config/keys");

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      programId: [],
      birthRequired: false,
      modelOpen: false,
      ShowThankMsg: false,
      ShowOtpBox: true,
      modelROpen: false,
      btnDisabled: true,
      ShowSignUp: false,
      showSignupForm: false
    };
  }

  onCloseRModal = () => {
    this.setState({ modelROpen: false });
  };
  onOpenModal = () => {
    this.setState({ modelOpen: true });
  };
  onCloseModal = () => {
    this.setState({ modelOpen: false });
  };
  birthDate = date => {
    this.setState({
      dateOfBirth: date
    });
    if (date) {
      this.setState({
        birthRequired: false
      });
    } else {
      this.setState({
        birthRequired: true
      });
    }
  };
  onInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onInputOtpChange = e => {
    this.setState({ [e.target.name]: e.target.value, errorMsg: false });
  };

  onInputGenderChange = e => {
    this.setState({
      genderId: e.target.value,
      gender: e.target[e.target.selectedIndex].text
    });
  };
  componentWillMount() {
    this.props.getAllAdvertisement();
  }
  componentDidUpdate() {
    updateGrid(this);
  }

  handleOtpSubmit = async e => {
    e.preventDefault();
    var userOtpData = {
      UserId: this.props.userRegistrationDetails.Id,
      OtpCode: this.state.otpNumber,
      userSignUp: true
    };
    var res = await this.props.checkUserVerifyOtpDetails(userOtpData);
    if (res.isOtpVerify) {
      this.setState({
        ShowThankMsg: true,
        ShowOtpBox: false,
        errorMsg: false
      });
    } else {
      this.setState({
        ShowThankMsg: false,
        ShowOtpBox: true,
        errorMsg: res.errorMsg
      });
    }
  };

  clearFormData() {
    this.setState({
      firstName: "",
      middleName: "",
      lastName: "",
      genderId: 0,
      dateOfBirth: undefined,
      nationality: 0,
      email: "",
      mobile: ""
    });
  }

  handleAdvertisementChange = selectedOption => {
    var objAdvertType = this.props.advertisementList.filter(
      item => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objAdvertType.length > 0) {
      this.setState({
        advertisementId: selectedOption.target.value || 0,
        advertisement: objAdvertType[0].Advertisement || ""
      });
    }
  };
  renderAdvertisement = () => {
    return _.sortBy(this.props.advertisementList, "Advertisement").map(data => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.Advertisement}
        </option>
      );
    });
  };

  handleCheckSignVerify = e => {
    this.setState({
      IsSignVerify: e.target.checked !== true ? 0 : 1,
      btnDisabled: false
    });
    if (!e.target.checked) {
      this.setState({ btnDisabled: true, ShowSignUp: false });
    }
  };

  showSubmit = () => {
    this.setState({ ShowSignUp: true, showSignupForm: true });
  };

  handleSubmit = async event => {
    event.preventDefault();

    var _dob = null;
    if (
      this.state.dateOfBirth !== undefined &&
      this.state.dateOfBirth !== null
    ) {
      _dob = moment(this.state.dateOfBirth).format("YYYY-MM-DD");
    }
    const registration = {
      FirstName: textToCapitalize(this.state.firstName),
      MiddleName: textToCapitalize(this.state.middleName),
      LastName: textToCapitalize(this.state.lastName),
      GenderId: parseInt(this.state.genderId, 10),
      Gender: this.state.gender,
      DOB: _dob,
      Nationality: this.state.nationality,
      Email: this.state.email,
      StudMobNo: this.state.mobile,
      SectionId: null,
      SyllabusId: [],
      //SignUpSmsTxt: keys.websiteSetting.SignUpSmsTxt,
      EmailHeaderContent: keys.websiteSetting.EmailHeaderContent,
      EmailFooterContent: keys.websiteSetting.EmailFooterContent,
      Advertisement: this.state.advertisement,
      IsActive: 1,
      IsDelete: 0,
      IsSignUp: 1,
      CreatedBy: 0,
      UpdatedBy: 0,
      Id: 0
    };

    if (_dob !== null) {
      var isRegSuccess = await this.props.registrationInquiryInsertUpdate(
        registration
      );
      if (isRegSuccess) {
        this.setState({ modelOpen: true, btnDisabled: true });
      } else {
        this.setState({
          modelROpen: true,
          IsSignVerify: false,
          btnDisabled: true
        });
        this.clearFormData();
      }
      this.setState({
        birthRequired: false
      });
    } else {
      this.setState({
        birthRequired: true
      });
    }
  };
  render() {
    if (
      this.props.auth.redirectToApplication === true &&
      this.props.auth.logOut === false &&
      this.props.auth.userType === 6
    ) {
      return <Redirect to="/Account/StudentAccount/AdmissionForm/0" />;
    }
    return (
      <div className="container d-table d-signup">
        <Modal
          open={this.state.modelROpen}
          onClose={this.onCloseRModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          classNames={{
            overlay: "modalMsgBox modalPopupDesign onlyReg",
            modal: "modalPopupInner"
          }}
        >
          <div className="regMassage">
            <div
              dangerouslySetInnerHTML={{
                __html: keys.websiteSetting.SignUpMsgModal
              }}
            />
            {/* Your mobile number is already registered.We have sent you username
            and password on your registered mobile no. */}
          </div>
        </Modal>

        <Modal
          open={this.state.modelOpen}
          onClose={this.onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          showCloseIcon={this.state.ShowThankMsg}
          classNames={{
            overlay: "modalMsgBox modalPopupDesign",
            modal: "modalPopupInner"
          }}
        >
          <Form
            onSubmit={this.handleOtpSubmit.bind(this)}
            className="text-center"
          >
            {this.state.ShowThankMsg && (
              <div className="regMassage">
                <div
                  dangerouslySetInnerHTML={{
                    __html: keys.websiteSetting.NewSignUpMsgModal
                  }}
                />
                {/* //Thank you for SignUp. */}
              </div>
            )}
            {this.state.ShowOtpBox && (
              <div className="modalVerify">
                <div className="regMassage modalTitle">
                  Please Verify OTP Number.
                </div>
                <div className="innerFormModal">
                  <div className="form-group">
                    <label className="required">Enter OTP</label>
                    <Input
                      type="number"
                      className="form-control otpBox"
                      id="otpNumber"
                      value={this.state.otpNumber}
                      validations={[validations.required]}
                      name="otpNumber"
                      label="OTP Number"
                      placeholder="Enter OTP"
                      onChange={this.onInputOtpChange}
                    />
                    {this.state.errorMsg && (
                      <p style={{ color: "#ff0000" }}>Invalid OTP</p>
                    )}
                  </div>

                  <div className="popupButtons">
                    <Button
                      type="submit"
                      className="btn btn-success btn-lg theme-btn"
                    >
                      Submit
                    </Button>
                    <button
                      type="button"
                      className="btn btn-info btn-lg theme-btn"
                      onClick={this.props.ResendOtpDetails.bind(this, {
                        UserId: this.props.userRegistrationDetails.Id,
                        StudMobNo: this.props.userRegistrationDetails.StudMobNo
                      })}
                    >
                      Resend OTP
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Form>
        </Modal>

        <div className="d-middel">
          <div
            className={
              keys.websiteSetting.signUpContent === "nvu"
                ? this.state.showSignupForm
                  ? "row justify-content-center signupContent boxHide"
                  : "row justify-content-center signupContent"
                : "row justify-content-center SignDivHeight"
            }
          >
            {keys.websiteSetting.signUpContent === "nvu" ? (
              <div
                className={
                  this.state.showSignupForm
                    ? "col-lg-7 col-md-7 col-sm-12 col-xs-12 displayHide"
                    : "col-lg-12 col-md-12 col-sm-12 col-xs-12 fullForm"
                }
              >
                <div className="regformLeftBg bgNuv">
                  <h3 className="text-center mb-3">
                    FOR NEW APPLICANTS / FRESHERS
                  </h3>
                  <div className="onlineNote">
                    <p className="mb-2">
                      <strong>
                        Applicant must ensure that he/she has the following
                        information in hand before proceeding for ‘Online
                        Application for Admission’ procedure:
                      </strong>
                    </p>
                    <ul>
                      <li>
                        <p className="mb-2">
                          Applicant’s functional <strong> E-MAIL ID </strong>{" "}
                          and
                          <strong> MOBILE NUMBER. </strong> [They will be used
                          for all future communications from the Navrachana
                          University]
                        </p>
                      </li>
                      <li>
                        <p className="mb-2">
                          <strong>
                            SCANNED COPY OF PASSPORT SIZE COLOR PHOTOGRAPH
                          </strong>{" "}
                          of the Applicant
                        </p>
                      </li>
                      <li>
                        <p className="mb-2">
                          Applicant’s <strong> Date of Birth Proof </strong>
                          (Providing Applicant’s Date of Birth Proof is
                          mandatory for successful completion of the
                          application)
                        </p>
                      </li>

                      <li>
                        <p className="mb-2">
                          Correct details of Residential address / Address for
                          communication with Proof
                        </p>
                      </li>
                      <li>
                        <p className="mb-2">
                          Necessary Mark-sheets &amp; Certificates of last
                          qualifying exam
                        </p>
                      </li>
                      <li>
                        <p className="mb-2">
                          Caste Certificate (If Applicable)
                        </p>
                      </li>
                      {/* <li>
                        <p className="mb-2"> Proof of Date of Birth </p>
                      </li>
                      <li>
                        <p className="mb-2"> Residence proof</p>
                      </li> */}
                    </ul>
                  </div>

                  <div className="form-group mb-0 mt-3">
                    <input
                      type="checkbox"
                      id="IsSignVerify"
                      name="IsSignVerify"
                      checked={this.state.IsSignVerify ? true : false}
                      onChange={this.handleCheckSignVerify}
                    />
                    <label className="checkbox-inline" htmlFor="IsSignVerify">
                      I confirm that I am in valid possession of above-mentioned
                      documents and I am a New Applicant / Fresher applying in
                      Navrachana University.
                    </label>
                  </div>

                  <p>
                    I am submitting all the above which may include other
                    personally identifiable information, voluntarily. I am fully
                    aware that Colleges, University, Government, their
                    associated agencies (Imaginations Softech Solutions Private
                    Limited) and their employees will use this information for
                    Academic, Administrative, Research, Internal Quality Audits
                    and Legal purposes and I am authorizing them for the same.
                  </p>
                  <p className="noteTextRed">
                    I authorize University to send text messages to my cell
                    phone from time to time to convey academic and
                    administrative information.
                  </p>
                  <button
                    type="button"
                    className="btn btn-success btn-lg theme-btn"
                    disabled={this.state.btnDisabled}
                    onClick={this.showSubmit}
                  >
                    <i className="fa fa-paper-plane" aria-hidden="true" />
                    Proceed
                  </button>
                  <p className="noteTextRed mb-0 pt-3 pb-4">
                    <strong>
                      Note: As the User Id and Password provided by the
                      University are important academic credentials, the
                      applicants as well students are instructed to preserve and
                      memorize the same for all future requirements. If
                      forgotten visit NUV Admission Cell at the University
                      Office along with identification proof for procuring the
                      User ID and Password.
                    </strong>
                  </p>
                </div>
              </div>
            ) : (
              <div className="col-lg-7 col-md-7 col-sm-12 signup_left" />
            )}

            <div
              className={
                keys.websiteSetting.signUpContent === "nvu"
                  ? this.state.showSignupForm
                    ? "col-lg-7 col-md-7 col-sm-12  signup_right"
                    : "col-lg-12 col-md-12 col-sm-12  signup_right fullwidthForm"
                  : "col-lg-5 col-md-5 signup_right"
              }
            >
              <div className="signup-card">
                <h2>SignUp For Admission</h2>
                <Form
                  onSubmit={this.handleSubmit.bind(this)}
                  className="reg-form-right textTransCapitalize"
                >
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">First Name</label>
                        <Input
                          type="text"
                          className="form-control"
                          id="firstName"
                          value={this.state.firstName || ""}
                          validations={[validations.required]}
                          name="firstName"
                          label="First Name"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>Middle Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="middleName"
                          value={this.state.middleName || ""}
                          name="middleName"
                          label="Middle Name"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Last Name</label>
                        <Input
                          type="text"
                          className="form-control"
                          id="lastName"
                          value={this.state.lastName || ""}
                          validations={[validations.required]}
                          name="lastName"
                          label="Last Name"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Gender</label>
                        <Select
                          className="form-control"
                          id="genderId"
                          validations={[validations.requiredSelect]}
                          name="genderId"
                          value={this.state.genderId}
                          label="Gender"
                          onChange={this.onInputGenderChange}
                        >
                          <option value="0">-- Select --</option>
                          <option value="1">Male</option>
                          <option value="2">Female</option>
                          <option value="3">Transgender</option>
                        </Select>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">DOB</label>
                        <DatePicker
                          selected={this.state.dateOfBirth}
                          onChange={this.birthDate}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          dateFormat={this.props.systemConfig.DateFormat}
                          maxDate={moment().subtract(15, "years")}
                          yearDropdownItemNumber={15}
                          scrollableYearDropdown
                          placeholderText="DD/MM/YYYY"
                          validations={[validations.required]}
                        />
                        {this.state.birthRequired && (
                          <span className="require_field">
                            Date OF Birth is Required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>Nationality</label>
                        <select
                          className="form-control"
                          id="nationality"
                          name="nationality"
                          value={this.state.nationality || ""}
                          label="Nationality"
                          onChange={this.onInputChange}
                        >
                          <option value="0">-- Select --</option>
                          <option>Indian</option>
                          <option>NRI</option>
                          <option>Foreigner</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        {keys.websiteSetting.signUpContent === "nvu" ? (
                          <label className="required">
                            How did you know about Navrachana University?
                          </label>
                        ) : (
                          <label className="required">
                            Where did you hear from?
                          </label>
                        )}
                        <Select
                          onChange={this.handleAdvertisementChange}
                          id="advertisementId"
                          name="advertisementId"
                          className="form-control"
                          value={this.state.advertisementId || 0}
                          validations={[validations.requiredSelect]}
                          label="Where did you here for"
                        >
                          <option value="0">-- Select --</option>
                          {this.renderAdvertisement()}
                        </Select>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Email</label>
                        <Input
                          type="email"
                          label="Email"
                          className="form-control"
                          id="email"
                          value={this.state.email || ""}
                          validations={[
                            validations.required,
                            validations.email
                          ]}
                          name="email"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Mobile</label>
                        <Input
                          type="number"
                          className="form-control"
                          id="mobile"
                          value={this.state.mobile || ""}
                          validations={
                            ([validations.required], [validations.minLength])
                          }
                          name="mobile"
                          label="Mobile"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>

                    <div className="col col-lg-12 mt-1">
                      <Button
                        type="submit"
                        className="btn btn-success btn-lg theme-btn"
                      >
                        <i className="fa fa-save" />
                        Sign Up
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps({
  auth,
  systemConfig,
  update,
  userRegistrationDetails,
  advertisementList
}) {
  return {
    auth,
    systemConfig,
    update,
    userRegistrationDetails,
    advertisementList
  };
}
export default connect(
  mapStateToProps,
  {
    registrationInquiryInsertUpdate,
    clearUpdate,
    checkUserVerifyOtpDetails,
    ResendOtpDetails,
    getAllAdvertisement
  }
)(SignUp);



// WEBPACK FOOTER //
// ./src/components/SignUp.js